import React, { useEffect, useMemo, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputNumber } from 'primereact/inputnumber';

const Preventivo = (props) => {

    const [preventivo, setPreventivo] = useState()
    const [prevTab, setPrevTab] = useState([])
    const [extraTab, setExtraTab] = useState([])
    const [visibleExtraTab, setVisibleExtraTab] = useState(false)

    // Create our number formatter.
    const formatter = useMemo(() => new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    }), [])

    useEffect(() => {
        debugger
        if (props.preventivo) {
            const _preventivo = { ...props.preventivo };

            /**flatmap gli array */
            Object.keys(_preventivo).forEach(chiave => {
                if (Array.isArray(_preventivo[chiave])) {
                    _preventivo[chiave].forEach((obj, ix) => {
                        _preventivo[chiave + (ix + 1)] = { ...obj, title: (obj.title || chiave) + " " + (ix + 1) };
                    })
                }
            });
            /**fine flatmap gli array */

            //*** calcolo subtotali e totalone ***
            let totalone = 0;
            Object.keys(_preventivo).forEach(function (key, index) {
                if (key !== 'infoPrel' && key !== 'TotalePreventivo') {
                    const subItem = _preventivo[key]

                    if (subItem) {
                        let totalino = 0;
                        Object.keys(subItem).forEach(function (sub, index2) {
                            //i totali delle singole sezioni sono calcolati nei componenti, devo solamente sommarli per determinale il totale della sezione
                            if (subItem[sub]?.tipologia === "SwitchConInput") {
                                
                                if (subItem[sub]?.totale){
                                    subItem[sub].totale = subItem[sub].prezzo * subItem[sub].quantita;
                                    totalino += subItem[sub].prezzo *  subItem[sub].quantita;
                                }
                                    //totalino += subItem[sub].totale;
                            }
                            /*if (subItem[sub]?.tipologia === "SwitchConNInput" || subItem[sub]?.tipologia === "ListaToggleButton") {*/
                            if (subItem[sub]?.tipologia === "SwitchConNInput") {

                                subItem[sub].valoriInput.forEach((inp) => {
                                    inp.totale = inp.prezzo * inp.quantita;
                                })
                                subItem[sub].prezzoFinale = subItem[sub].valoriInput.filter(v=> v.totale).reduce((accumulator, currentValue) => accumulator + currentValue.totale ,0,) 
                                if (subItem[sub]?.prezzoFinale)
                                    totalino += subItem[sub].prezzoFinale;
                            }
                            if (subItem[sub]?.tipologia === "ListaToggleButton") {
debugger
                                subItem[sub].valore.forEach((inp) => {
                                    if(inp.num > 0)
                                        inp.totale = inp.prezzo * inp.num;
                                })
                                subItem[sub].prezzoFinale = 0
                                subItem[sub].prezzoFinale = subItem[sub].valore.filter(v=> v.totale).reduce((accumulator, currentValue) => accumulator + currentValue.totale ,0,) 
                                if(subItem[sub].ancheInput){
                                    subItem[sub].prezzoFinale += subItem[sub].prezzoAncheInput * subItem[sub].quantitaAncheInput;
                                }
                                if (subItem[sub]?.prezzoFinale)
                                    totalino += subItem[sub].prezzoFinale;
                            }
                        })
                        subItem.totale = totalino; //totale della sezione del preventivo
                        totalone += totalino; //totale del preventivo
                    }
                }

            })

            _preventivo.TotalePreventivo = totalone;
            //*** FINE calcolo subtotali e totalone ***


            //appiattisce il preventivo come tipo, descrizone, prezzo, quantità, subtotal per renderizzare la tabella
            const _prevTab = []
            //tabella degli extra
            const _extraTab = []

            Object.keys(_preventivo).forEach(function (key, index) {
                // key: the name of the object key
                // index: the ordinal position of the key within the object 
                if (key !== 'infoPrel' && key !== 'TotalePreventivo') {
               // if ( key !== 'TotalePreventivo') {
                    const subItem = _preventivo[key]

                    if (subItem && subItem.totale && subItem.totale !== 0) {
                        Object.keys(subItem).forEach(function (sub, index2) {

                            if (subItem[sub]?.tipologia === "SwitchConInput") {
                                if (subItem[sub]?.totale > 0) {
                                    _prevTab.push({
                                        indexType: index,
                                        indexDesc: index2,
                                        type: subItem.title || key,
                                        desc: subItem[sub].titolo,
                                        prezzo: subItem[sub].prezzo,
                                        unita_misura: (subItem[sub].descQuantita ? '/' + subItem[sub].descQuantita : '') + (subItem[sub].prezzoBase ? ('(+ ' + subItem[sub].prezzoBase + '€)') : ''),
                                        quantita: subItem[sub].quantita + ' ' + subItem[sub].descQuantita,
                                        subtotal: formatter.format(subItem[sub].totale)
                                    });
                                }
                            }
                            if (subItem[sub]?.tipologia === "SwitchConNInput") {
                                if (subItem[sub]?.prezzoFinale > 0) {
                                    subItem[sub].valoriInput.forEach((inp,index3) => {
                                        
                                        if (inp.quantita > 0) {
                                            
                                            _prevTab.push({
                                                indexType: index,
                                                indexDesc: index2,
                                                indexInput:index3,
                                                type: subItem.title || key,
                                                desc: subItem[sub].titolo + ': ' + inp.nome,
                                                prezzo: inp.prezzo,
                                                unita_misura: inp.descQuantita,
                                                quantita: inp.quantita + ' ' + inp.descQuantita,
                                                subtotal: formatter.format(inp.totale)
                                            });
                                        }
                                    })
                                }
                            }
                            if (subItem[sub]?.tipologia === "ListaToggleButton") {

                                if (subItem[sub]?.prezzoFinale > 0) {
                                    subItem[sub].valore.forEach((inp, index3) => {
                                        if (inp.num > 0) {
                                            _prevTab.push({
                                                indexType: index,
                                                indexDesc: index2,
                                                indexInput:index3,
                                                type: subItem.title || key,
                                                desc: subItem[sub].titolo + ': ' + inp.nome,
                                                prezzo: inp.prezzo,
                                                unita_misura: '/u',
                                                quantita: inp.num + ' u',
                                                subtotal: formatter.format(inp.totale)
                                            });
                                        }
                                    })

                                    if (subItem[sub].quantitaAncheInput > 0) {
                                        _prevTab.push({
                                            indexType: index,
                                            indexDesc: index2,
                                            type: subItem.title || key,
                                            desc: subItem[sub].titolo + ': Altri',
                                            prezzo: subItem[sub].prezzoAncheInput,
                                            unita_misura: '/u',
                                            quantita: subItem[sub].quantitaAncheInput + ' u',
                                            subtotal: formatter.format(subItem[sub].totaleAncheInput)
                                        });
                                    }
                                }
                            }

                            //extra
                            if (subItem[sub]?.extra) {
                                //una sola voce per descrizione uguale
                                if (_extraTab.filter(jj => jj.desc === subItem[sub].extra.descrizione).length === 0) {
                                    _extraTab.push({                                        
                                        type: "Extra",
                                        desc: subItem[sub].extra.descrizione,
                                        prezzo: null,
                                        unita_misura: null,
                                        quantita: null,
                                        //subtotal: formatter.format(subItem[sub].totale*subItem[sub]?.extra.percentuale/100)
                                        subtotal: 'da definire'
                                    });
                                }
                            }
                        })

                        if (subItem.totale > 0) {
                            _prevTab.push({
                                //indexType: index,
                                //indexDesc: index2,
                                type: subItem.title || key,
                                className: "p-text-secondary font-bold ",
                                desc: "Totale " + subItem.title || key,
                                prezzo: null,
                                unita_misura: null,
                                quantita: null,
                                subtotal: formatter.format(subItem.totale)
                            });
                        }

                    }

                } else if (key !== 'infoPrel') {
                    if (_preventivo.infoPrel?.pianoSelezionato?.code >= 3) {
                        _extraTab.push({
                            type: "Extra",
                            desc: "Costo carico e scarico",
                            prezzo: null,
                            unita_misura: null,
                            quantita: null,
                            subtotal: 'da definire dopo sopralluogo'
                        });
                    }
                }
            });

            setPreventivo(_preventivo)
            setPrevTab(_prevTab)
            setExtraTab(_extraTab)

            debugger
            if (props.onCalculate) {
                props.onCalculate(_preventivo, _prevTab, _extraTab)
            }
        }

    }, [props.preventivo])


    const headerGroupTemplate = (data) => {
        return (
            <span className="font-bold">{data.type}</span>
        )
    }

    const footerGroupTemplate = (data) => {
        /*  return (
             <div className="font-bold text-right">Totale : {data.totale}</div>
         ) */
    }

    const footerTemplate = () => {
        return (
            <div className="font-bold text-right">Totale preventivo: {formatter.format(preventivo.TotalePreventivo)}</div>
        )
    }

    const priceEditor = (options) => {
        if (options.rowData['unita_misura']) {
            return (<div className='flex gap-1'>
                <InputNumber value={options.value}
                    onValueChange={(e) => options.editorCallback(e.value)}
                    mode="currency" currency="EUR"
                    locale="it-IT"
                    onKeyDown={(e) => e.stopPropagation()} />
                <div>{options.rowData['unita_misura']}</div>
                
            </div>
            )
        } else return <></>
    }

    const isPositiveInteger = (val) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    }

    const onRowEditComplete = (e) => {
       
        let { newData, index } = e;

        if (isPositiveInteger(newData.prezzo)) {

            //rowData['prezzo'] = newValue;
            
            const _prev = {...preventivo}
            const chiave_type = Object.keys(_prev)[newData.indexType]
            const obj_type = _prev[chiave_type]
            const chive_ogget = Object.keys(obj_type)[newData.indexDesc]
            const obj_ogget = obj_type[chive_ogget]
            if(newData.indexInput  !== undefined){
                if(obj_ogget.valoriInput)
                    obj_ogget.valoriInput[newData.indexInput].prezzo =  newData.prezzo
                else 
                    obj_ogget.valore[newData.indexInput].prezzo =  newData.prezzo
            }else{
                obj_ogget.prezzo = newData.prezzo
            }
            props.onChangePrev(_prev)
            
        } else e.originalEvent.preventDefault();

    }

    const priceBodyTemplate = (rowData) => {
        if (rowData.unita_misura)
            return (
                <div>
                    {new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(rowData.prezzo)} {rowData.unita_misura}
                </div>)
        else return <></>
    }

    const allowEdit = (rowData) => {
        return rowData.unita_misura ? true : false;
    }

console.log("******",prevTab)


    if (!preventivo)
        return (<></>)

    return (
        <>
            <h1>
                Preventivo
            </h1>
            <div className='flex flex-column md:flex-row align-items-center gap-2'>
                {preventivo.infoPrel &&
                    <div className='flex-grow-1'>
                        <div>
                            <b>Tipologia</b>: {preventivo.infoPrel.tipologia}
                        </div>
                        <div>
                            <b>Metri quadri abitazione</b>: {preventivo.infoPrel.mq} mq
                        </div>
                        <div>
                            <b>Piano</b>: {preventivo.infoPrel.pianoSelezionato?.name}
                        </div>
                    </div>}
                <div className=''>
                    {props.commandTemplate}
                </div>
            </div>

        

            <DataTable 
                value={prevTab}
                emptyMessage="Nessuna opzione scelta"
                editMode="row"  
                onRowEditComplete={onRowEditComplete}
                rowGroupMode="subheader"
                groupRowsBy="type" 
                size={'small'}
                rowGroupHeaderTemplate={headerGroupTemplate} 
                rowGroupFooterTemplate={footerGroupTemplate}
                footer={localStorage.getItem("chiave")?footerTemplate:<></>} 
                className='mt-4'
            >
                <Column style={{ minWidth: '10px' }}></Column>
                <Column field="desc" header="Descrizione" align={'left'} style={{ minWidth: '200px' }} bodyClassName={(data) => { return data.className }}></Column>
            
                 {localStorage?.getItem("chiave") &&
                    <Column 
                        field="prezzo" 
                        header="Prezzo" 
                        align={'right'} 
                        style={{ minWidth: '100px'}}
                        bodyClassName={(data) => { return data.className }}
                        editor={(options) => priceEditor(options)}
                        body={priceBodyTemplate}
                    />
                    
                }
                <Column field="quantita" header="Quantità" align={'right'} style={{ minWidth: '100px' }} bodyClassName={(data) => { return data.className }}></Column>
                {localStorage?.getItem("chiave") && <Column field="subtotal" header="Sub.tot" align={'right'} style={{ minWidth: '100px' }} bodyClassName={(data) => { return data.className }}></Column>}
                { props.abilitaModifica && localStorage?.getItem("chiave")  && <Column rowEditor={allowEdit} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>}
            </DataTable>
            

            {visibleExtraTab && extraTab.length > 0 &&
                <DataTable value={extraTab} rowGroupMode="subheader" groupRowsBy="type" size={'small'}
                    rowGroupHeaderTemplate={headerGroupTemplate} showHeaders={false}
                    className='mt-4'
                >
                    <Column style={{ minWidth: '10px' }}></Column>
                    <Column field="desc" align={'left'} style={{ minWidth: '200px' }} bodyClassName={(data) => { return data.className }}></Column>
                  {localStorage?.getItem("chiave") &&  <Column field="prezzo" align={'right'} style={{ minWidth: '100px' }} bodyClassName={(data) => { return data.className }}></Column>}
                    <Column field="quantita" align={'right'} style={{ minWidth: '100px' }} bodyClassName={(data) => { return data.className }}></Column>
                    {localStorage?.getItem("chiave") && <Column field="subtotal" align={'right'} style={{ minWidth: '100px' }} bodyClassName={(data) => { return data.className }}></Column>}
                    
                
                </DataTable>
            }

        </>
    )
}

export default Preventivo